// extracted by mini-css-extract-plugin
export default {"image":"Gaia_image__jR9CS"};